var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/20231212/dy_qrcode.png")}}),_c('canvas',{attrs:{"id":"myCanvas","width":"115","height":"115"}})])
}]

export { render, staticRenderFns }